import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import classNames from "classnames";
import UiIconSmallRight from "@dcl/icons/esm/ui/small-right";
import getClassNameFactory from "../../../../../../utilities/classNames";

var Tab = /*#__PURE__*/function (_React$Component) {
  _inherits(Tab, _React$Component);

  var _super = _createSuper(Tab);

  function Tab() {
    var _this;

    _classCallCheck(this, Tab);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "ref", void 0);

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (oldProps) {
      var siteHeaderViewportWidth = 1200; // When a tab is selected, make it gain the focus. This ensures that a
      // keyboard user doesn't get lost on the page. In particular, it covers the
      // case of focusing the tab when switching tabs with arrow keys.
      //
      // Only apply this behaviour above the SiteHeader viewport width, where the
      // "tabs" UI pattern is used.

      if (window.innerWidth >= siteHeaderViewportWidth && _this.ref && !oldProps.selected && _this.props.selected) {
        _this.ref.focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      _this.props.onClick(e, _this.props.relatedId);
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      _this.props.onKeyDown(e);
    });

    _defineProperty(_assertThisInitialized(_this), "registerRef", function (ref) {
      if (ref) {
        _this.ref = ref;
      }
    });

    return _this;
  }

  _createClass(Tab, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          relatedId = _this$props.relatedId,
          selected = _this$props.selected,
          title = _this$props.title;
      var getClassName = getClassNameFactory(Tab.displayName);
      var anchorProps = {
        className: getClassName({
          descendantName: "link"
        }),
        href: "#".concat(relatedId),
        onClick: this.handleClick,
        onKeyDown: this.handleKeyDown,
        id: "tab-".concat(relatedId),
        role: "tab"
      };

      if (selected) {
        anchorProps["aria-selected"] = true;
      }

      return /*#__PURE__*/React.createElement("li", {
        role: "presentation",
        className: getClassName({
          states: classNames({
            selected: selected
          })
        })
      }, /*#__PURE__*/React.createElement("a", _extends({}, anchorProps, {
        ref: this.registerRef,
        target: "_self"
      }), title, /*#__PURE__*/React.createElement("span", {
        className: getClassName({
          descendantName: "icon"
        })
      }, /*#__PURE__*/React.createElement(UiIconSmallRight, {
        width: 24
      }))));
    }
  }]);

  return Tab;
}(React.Component);

_defineProperty(Tab, "displayName", "SiteHeader.Flyouts.Tab");

_defineProperty(Tab, "defaultProps", {
  onClick: function onClick() {},
  onKeyDown: function onKeyDown() {}
});

export default Tab;